import Vue from 'vue'
import { parseTime } from 'utils/index';

const date = Vue.filter('toDate', function (value) {
  return parseTime(value, '{y}-{m}-{d}');
});
const time = Vue.filter('toTime', function (value) {
  return parseTime(value, '{y}-{m}-{d} {h}:{i}:{s}');
});

const integerPrice = Vue.filter('integerPrice', function (value) {
  var integerPrice = '';
  var decimals = value.toString().split(".");
  integerPrice = decimals[0];
  return integerPrice
})

const decimalsPrice = Vue.filter('decimalsPrice', function (value) {
  var decimalsPrice = '';
  var decimals = value.toString().split(".");
  if (decimals.length > 1) {
    decimalsPrice = decimals[1];
    if (decimals[1].length === 1) {
      decimalsPrice = decimalsPrice + '0'
    }
  } else {
    decimalsPrice = "00";
  }
  return decimalsPrice
})

export default {
  date,
  time,
  integerPrice,
  decimalsPrice
}
